<ng-container *ngIf="(getActivePublication$ | async) as publication">
  <!--  <ng-container *ngIf="(obsSelectedCommunities$|async) as communitiesList">-->
  <ng-container *ngIf="(communitiesService.selectListById$(selectedCommunities)|async) as communitiesList">

    <span class="mat-headline-5 p-8">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true"
        focusable="false" width="24" height="24"
        style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
        preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20">
        <path
          d="M17.74 2.76a4.321 4.321 0 0 1 0 6.1l-1.53 1.52c-1.12 1.12-2.7 1.47-4.14 1.09l2.62-2.61l.76-.77l.76-.76c.84-.84.84-2.2 0-3.04a2.13 2.13 0 0 0-3.04 0l-.77.76l-3.38 3.38c-.37-1.44-.02-3.02 1.1-4.14l1.52-1.53a4.321 4.321 0 0 1 6.1 0zM8.59 13.43l5.34-5.34c.42-.42.42-1.1 0-1.52c-.44-.43-1.13-.39-1.53 0l-5.33 5.34c-.42.42-.42 1.1 0 1.52c.44.43 1.13.39 1.52 0zm-.76 2.29l4.14-4.15c.38 1.44.03 3.02-1.09 4.14l-1.52 1.53a4.321 4.321 0 0 1-6.1 0a4.321 4.321 0 0 1 0-6.1l1.53-1.52c1.12-1.12 2.7-1.47 4.14-1.1l-4.14 4.15c-.85.84-.85 2.2 0 3.05c.84.84 2.2.84 3.04 0z"
          fill="black" />
      </svg>
      {{'Générateur de liens' | translate}}</span>

    <ng-container *ngIf="(communitiesService.communitiesListState$|async).refreshList.isLoading">
      <app-is-loading [message]="'Chargement des communautés' | translate"></app-is-loading>
    </ng-container>

    <div *ngIf="!(communitiesService.communitiesListState$|async).refreshList.isLoading" appFlex appFlexLayout="column">

      <!-- PARAMS DES LIENS     -->
      <div appFlex appFlexLayout="column" class="">

        <div appFlex="auto" appFlexLayout="row" appFlexAlign="center center" class="p-8">

          <div appFlex="50" appFlexLayout="column" class="w-100-p">

            <div appFlex *ngIf="!publication.datas.generalInfo.contributors.inbe || communitiesList.length === 0">
              {{'Pas de communauté Inbe sélectionnée' | translate}}
            </div>
            <dx-drop-down-box *ngIf="publication.datas.generalInfo.contributors.inbe && communitiesList.length > 0"
              [(value)]="selectedCommunities" width="100%" valueExpr="communityId" displayExpr="communityTitle"
              [placeholder]="'Sélectionner une ou plusieurs communautés'|translate" [showClearButton]="true"
              [dataSource]="communitiesList">
              <div *dxTemplate="let data of 'content'">
                <dx-data-grid [dataSource]="communitiesList" [columns]="['communityTitle']" keyExpr="communityId"
                  [selection]="{ mode: 'multiple', showCheckBoxesMode: 'always' }" [hoverStateEnabled]="true"
                  [paging]="{ enabled: true, pageSize: 10 }" [filterRow]="{ visible: false }" [showColumnLines]="false"
                  [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="false" [headerFilter]="false"
                  [showColumnHeaders]="false" [scrolling]="{ mode: 'infinite' }" [height]="345"
                  [(selectedRowKeys)]="selectedCommunities">
                </dx-data-grid>
              </div>

            </dx-drop-down-box>

            <div appFlex *ngIf="publication.datas.generalInfo.contributors.cint" class="p-4">
              <mat-checkbox [formControl]="cintCommunitySelected" class="example-margin">{{'Communauté
                Cint'|translate}}</mat-checkbox>
            </div>

          </div>

          <div appFlex="50" class="options w-100-p" appFlexAlign="end center">

            <div appFlex appFlexLayout="column">
              <mat-checkbox [formControl]="modePublicationOnly" class="block">
                <i class="mdi mdi-flag-variant"></i>
                <strong>{{'Publication seulement'|translate}}</strong>
              </mat-checkbox>
              <mat-checkbox [formControl]="modeTestSelected" class="block">
                <i class="mdi mdi-test-tube"></i> {{'Mode test'|translate}}
              </mat-checkbox>
            </div>

            <mat-form-field *ngIf="!publication.datas.generalInfo.hasV2Survey" class="block lang-selector">
              <mat-select [formControl]="selectedLang">
                <mat-option *ngFor="let lang of langsAvailables" [value]="lang">
                  <span class="flag-emoji">{{getLanguageInfo(lang).flag}}</span>
                  <span class="lang-name">{{getLanguageInfo(lang).name}}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>

          </div>
        </div>

        <div class="message-box warning m-4" *ngIf="!publication.datas.generalInfo.published">
          {{'La publication n\'est pas active.'|translate}}<br>
          {{'Utiliser le'|translate}} <a href="#" (click)="enableTestMode()">{{'mode test'|translate}}</a> {{'pour
          pouvoir voir les questionnaires une fois dans le projet.'}}.
        </div>

        <div *ngIf="!publication.datas.generalInfo.hasV2Survey" appFlex class="p-4">
          <mat-checkbox [formControl]="forceLang" class="example-margin">
            {{'Ne pas proposer le choix de la langue'|translate}}
            ({{'la langue' | translate}} <b>{{selectedLang.value}}</b> {{'sera utilisée.' | translate}})
          </mat-checkbox>
        </div>


        <div class="w-100-p m-2" *ngIf="publication.datas.generalInfo.hasV2Survey">
          <div appFlex="nogrow" appFlexLayout="column" class="mat-elevation-z2 p-8 w-100-p">
            <span class="mat-headline-6">{{'Langues'|translate}}</span>
            <div appFlexLayout="row" appFlexAlign="start center">
              <div appFlex="grow">{{'Langue d\'atterrissage par défaut'|translate}}:</div>
              <mat-select [formControl]="selectedLang" class="lang-selector-inline">
                <mat-select-trigger>
                  <span class="flag-emoji">{{getLanguageInfo(selectedLang.value).flag}}</span>
                  <span class="lang-name">{{getLanguageInfo(selectedLang.value).name}}</span>
                </mat-select-trigger>
                <mat-option *ngFor="let lang of publication.datas.generalInfo.availablesLang" [value]="lang">
                  <span class="flag-emoji">{{getLanguageInfo(lang).flag}}</span>
                  <span class="lang-name">{{getLanguageInfo(lang).name}}</span>
                </mat-option>
              </mat-select>
            </div>
            <div appFlexLayout="column" class="">
              <div appFlex>
                <mat-checkbox [formControl]="askLang" class="example-margin">
                  {{'Demander systématiquement la langue au participant parmi'|translate}}
                  &nbsp;{{publication.datas.generalInfo.availablesLang|json}}
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>


      </div>

      <!-- LISTE DES LIENS -->
      <div appFlex="auto" appFlexLayout="column" class="p-8">

        <!-- Communities       -->
        <ng-container *ngFor="let aCom of communitiesList">

          <div appFlex="nogrow" *ngIf="selectedCommunities?.includes(aCom.communityId)" appFlexLayout="column"
            class="mat-elevation-z2 p-8">
            <span class="mat-headline-6">{{aCom.communityTitle}}</span>

            <ng-container *ngIf="!publication.datas.generalInfo.hasV2Survey">
              <app-url-placeholder [url]="getUrlLink(aCom.projectSlug, aCom.communityId, false)"></app-url-placeholder>
              <pre
                *ngIf="publication.uxInteractions.debugMode">{{getUrlLink(aCom.projectSlug, aCom.communityId, false)}}</pre>
            </ng-container>
            <ng-container *ngIf="publication.datas.generalInfo.hasV2Survey">
              <app-url-placeholder
                [url]="getUrlLink(aCom.projectSlug, aCom.communityId, false, true)"></app-url-placeholder>
              <pre
                *ngIf="publication.uxInteractions.debugMode">{{getUrlLink(aCom.projectSlug, aCom.communityId, false, true)}}</pre>
            </ng-container>

          </div>

        </ng-container>

        <!-- Cint       -->
        <app-cint-link class="mt-7" [displayTitle]="true" [modeTestSelected]="modeTestSelected.value"
          [selectedLang]="selectedLang?.value" [forceLang]="forceLangParam" [askLang]="askLang?.value">

        </app-cint-link>

      </div>

      <span appFlex="grow"></span>

    </div>

  </ng-container>
</ng-container>